import TeamResult from '@/classes/TeamResult';
import { TeamResultMonth } from '@/classes/TeamResultMonth';

export async function ImportResultData(worksheet)
{
    const lastRow = worksheet.lastRow.number;
    const lastCol = worksheet.actualColumnCount;
    console.log('[ImportResult](ImportResultData) Last col', lastCol);

    const teamResults = [];

    let currentTeamResult = null;

    let resultFirstMonthColumn = 0;

    for (let r = 1; r <= lastRow; r++)
    {
        const row = worksheet.getRow(r);
        const colA_Cell = row.getCell(1);

        // Check for '【' because it means we are
        // separating by internal teams/groups
        if (typeof colA_Cell.value === typeof 'string' &&
            colA_Cell.value.includes('部別決算') === true &&
            colA_Cell.value.includes('【') === true)
        {
            const year = ExtractYear(colA_Cell.value);
            const teamName = ExtractTeam(colA_Cell.value);
            
            if (currentTeamResult !== null)
            {
                teamResults.push(currentTeamResult);
            }

            // We don't want entries in the DB with "unsupported teamname".
            // If this happens, we have to adjust the name list inside "GetTeamName".
            if (teamName === 'Unsupported_TeamName')
            {
                currentTeamResult = null;
                continue;
            }
            
            currentTeamResult = new TeamResult(teamName, year);

            // Look for the month row and first month column
            for (let newR = r; newR <= lastRow; newR++)
            {
                const newRow = worksheet.getRow(newR);
                for (let col = 1; col <= lastCol; col++)
                {
                    const newCol = newRow.getCell(col);

                    if (typeof newCol.value === typeof 'string' &&
                        newCol.value.includes('月') === true)
                    {
                        resultFirstMonthColumn = col;
                        break;
                    }
                }
            }
        }
        else if (currentTeamResult !== null)
        {
            // Check if in col B is something written too
            const colB_Cell = row.getCell(2);
            if (typeof colB_Cell.value === typeof 'string')
            {
                switch(colB_Cell.value)
                {
                    case '販売コミッション':
                        for (let m = 0; m < 12; m++)
                        {
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            currentTeamResult.TeamResultMonth[m].salesCommission = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;

                    case 'EC決済手数料':
                        for (let m = 0; m < 12; m++)
                        {
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            currentTeamResult.TeamResultMonth[m].ecPaymentFees = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;

                    case '国内流通作業費':
                        for (let m = 0; m < 12; m++)
                        {
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            currentTeamResult.TeamResultMonth[m].domesticDistributionCosts = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;

                    case '倉庫保管料':
                        for (let m = 0; m < 12; m++)
                        {
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            currentTeamResult.TeamResultMonth[m].warehouseStorageFee = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;

                    case '出荷運賃':
                        for (let m = 0; m < 12; m++)
                        {
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            currentTeamResult.TeamResultMonth[m].shippingFee = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;

                    case '金型償却費':
                        for (let m = 0; m < 12; m++)
                        {
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            currentTeamResult.TeamResultMonth[m].moldAmortization = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;

                    case '原型償却費':
                        for (let m = 0; m < 12; m++)
                        {
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            currentTeamResult.TeamResultMonth[m].sculptAmortization = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;

                    case '著作権料':
                        for (let m = 0; m < 12; m++)
                        {
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            currentTeamResult.TeamResultMonth[m].copyrightFees = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;
                }
            }
            else
            {
                switch(colA_Cell.value)
                {
                    case '売上':
                        for (let m = 0; m < 12; m++)
                        {
                            // The values start from column B -> + 2
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            console.log(`[ImportResult] ${(m + 1)}月 (${currentTeamResult.Team}) Sales from row ${row.number} column ${m + resultFirstMonthColumn}`);
                            currentTeamResult.TeamResultMonth[m].Sales = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;

                    case '営業総益(仮)':
                        for (let m = 0; m < 12; m++)
                        {
                            // The values start from column B -> + 2
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            currentTeamResult.TeamResultMonth[m].Prov_GrossOperatingProfit = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;

                    case 'ｸﾚｰﾑ調整':
                        for (let m = 0; m < 12; m++)
                        {
                            // The values start from column B -> + 2
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            currentTeamResult.TeamResultMonth[m].ClaimAdjustment = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;

                    case '洗替実績':
                        for (let m = 0; m < 12; m++)
                        {
                            // The values start from column B -> + 2
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            currentTeamResult.TeamResultMonth[m].WashedResult = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;

                    case '営業総益':
                        for (let m = 0; m < 12; m++)
                        {
                            // The values start from column B -> + 2
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            currentTeamResult.TeamResultMonth[m].GrossOperatingProfit = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;

                    case '原価算入外経費':
                        for (let m = 0; m < 12; m++)
                        {
                            // The values start from column B -> + 2
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            currentTeamResult.TeamResultMonth[m].NonCostExpenses = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;

                    case '準営業利益':
                        for (let m = 0; m < 12; m++)
                        {
                            // The values start from column B -> + 2
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            currentTeamResult.TeamResultMonth[m].QuasiOperatingProfit = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;

                    case 'チーム共通費':
                        for (let m = 0; m < 12; m++)
                        {
                            // The values start from column B -> + 2
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            currentTeamResult.TeamResultMonth[m].TeamCommonExpenses = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;

                    case '在庫ﾍﾟﾅﾙﾃｨ':
                        for (let m = 0; m < 12; m++)
                        {
                            // The values start from column B -> + 2
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            currentTeamResult.TeamResultMonth[m].StockPenalty = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;

                    case '減価償却':
                        for (let m = 0; m < 12; m++)
                        {
                            // The values start from column B -> + 2
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            currentTeamResult.TeamResultMonth[m].Depreciation = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;

                    case '事業営業利益':
                    case '営業利益':
                        for (let m = 0; m < 12; m++)
                        {
                            // The values start from column B -> + 2
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            currentTeamResult.TeamResultMonth[m].OperatingProfit = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;

                    case '人件費':
                        for (let m = 0; m < 12; m++)
                        {
                            // The values start from column B -> + 2
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            currentTeamResult.TeamResultMonth[m].StaffCost = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;

                    case '純利益':
                        for (let m = 0; m < 12; m++)
                        {
                            // The values start from column B -> + 2
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            currentTeamResult.TeamResultMonth[m].NetIncome = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;

                    case '在庫':
                        for (let m = 0; m < 12; m++)
                        {
                            // The values start from column B -> + 2
                            const cell = row.getCell(m + resultFirstMonthColumn);
                            if (currentTeamResult.TeamResultMonth.length <= m)
                            {
                                currentTeamResult.TeamResultMonth.push(new TeamResultMonth(m + 1));
                            }
                            currentTeamResult.TeamResultMonth[m].Stock = parseInt(cell.result !== undefined ? cell.result : cell.value);
                        }
                        break;
                }
            }
        }
    }

    // We don't need the total values
    for (let i = 0; i < teamResults.length; i++)
    {
        if (teamResults[i].Team === '3部合計')
        {
            teamResults.splice(i, 1);
        }
        else
        {
            // Make sure we have at least a valid
            // number in each field
            const t = teamResults[i];
            for (let j = 0; j < t.TeamResultMonth.length; j++)
            {
                const m = t.TeamResultMonth[j];
                for (const key in m)
                {
                    if (isNaN(m[key]) === true)
                    {
                        m[key] = 0;
                    }
                }
            }
        }
    }

    return teamResults;
}

// Eg.: 2023部別決算【トイホビー】
function ExtractYear(string)
{
    const yearMatch = string.match(/\d{4}/); 
    return yearMatch ? yearMatch[0] : null;
}

// Eg.: 2023部別決算【トイホビー】
function ExtractTeam(string)
{
    const teamMatch = string.match(/【(.+?)】/);
    return teamMatch ? GetTeamName(teamMatch[1]) : null;
}

function GetTeamName(sheetName)
{
    switch(sheetName)
    {
        case "Toy":
        case "toy":
        case "3部第1チーム【トイホビー】":
        case "3部第1チーム【トイ・ホビー】":
        case "【トイ・ホビー】":
        case "【トイホビー】":
        case "3部【トイ・ホビー】":
        case "2024部別決算【トイホビー】":
        case "トイ・ホビー":
        case "411":
        case "トイホビー":
        case "フィギュア":
        case "フィギュアー":
            return "トイホビー";

        case "モデルキット":
            return "プラモ";

        case "XPNA":
            return "XPNA";

        case "3部第2チーム【ゲーム開発】":
        case "【ゲーム開発】":
        case "3部【ゲーム開発】":
        case "2024部別決算【ゲーム開発】":
        case "GAME":
        case "421":
        case "ゲーム開発":
            return "ゲーム開発";

        case "3部第2チーム【デジタル】":
        case "【デジタル】":
        case "3部【デジタル】":
        case "2024部別決算【デジタル】":
        case "414":
        case "デジタル":
            return "デジタル";

        // This is probably not necessary
        case "2023部別決算【3部合計】":
            console.log("(2023)3Bu TTL not yet implemented: ");
            return "Unsupported_TeamName";

        // This is probably not necessary
        case "2024部別決算【3部合計】":
            console.log("(2024)3Bu TTL not yet implemented: ");
            return "Unsupported_TeamName";

        default:
            console.log("Unsupported team name: " + sheetName);
            return "Unsupported_TeamName";
    }
}